export default __webpack_public_path__ + "static/media/HealthSmartLogo.91809f85.png";